import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useParams} from "react-router-dom";
import {baseUrl, ipAddress, userName} from "../Univ";
function WorkerDisputes() {
    const {assignmentId} = useParams();
    const [disputes, setDisputes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        description: ""
    });
    // ---------------- FETCH DISPUTES ----------------
    const fetchDisputes = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                baseUrl + "dispute-assignment/" + assignmentId + "/"
            );
            setDisputes(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDisputes();
    }, [assignmentId]);
    // ---------------- HANDLE CHANGE ----------------
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    // ---------------- CREATE DISPUTE ----------------
    const createDispute = async (e) => {
        e.preventDefault();
        if (!formData.title) {
            Swal.fire(
                "Error",
                "Enter dispute title",
                "error"
            );
            return;
        }
        if (!formData.description) {
            Swal.fire(
                "Error",
                "Enter dispute description",
                "error"
            );
            return;
        }
        const fd = new FormData();
        fd.append("assignment", assignmentId);
        fd.append("raised_by", "WORKER");
        fd.append("title", formData.title);
        fd.append("description", formData.description);
        fd.append("status", "OPEN");
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        try {
            await axios.post(
                baseUrl + "dispute/",
                fd
            );
            Swal.fire(
                "Success",
                "Dispute Raised Successfully",
                "success"
            );
            setFormData({
                title: "",
                description: ""
            });
            fetchDisputes();
        } catch (err) {
            console.log(err.response?.data);
            Swal.fire(
                "Error",
                "Unable to raise dispute",
                "error"
            );
        }
    };
    return (
        <section className="container mt-4">

            <h3 className="mb-4">
                Raise Dispute
            </h3>

            {/* CREATE DISPUTE */}

            <div className="card shadow mb-4">

                <div className="card-header">
                    New Dispute
                </div>

                <div className="card-body">

                    <input
                        type="text"
                        className="form-control mb-3"
                        placeholder="Dispute Title"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                    />

                    <textarea
                        rows="4"
                        className="form-control mb-3"
                        placeholder="Describe your issue..."
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                    />

                    <button
                        className="btn btn-danger"
                        onClick={createDispute}
                    >
                        Raise Dispute
                    </button>

                </div>

            </div>

            {/* LOADING */}

            {loading && (
                <div className="alert alert-info">

                    Loading Disputes...

                </div>
            )}

            {/* NO DISPUTES */}

            {!loading && disputes.length === 0 && (
                <div className="alert alert-warning">

                    No Disputes Found

                </div>
            )}

            {/* DISPUTE LIST */}

            <div className="row">

                {disputes.map((item) => (
                    <div
                        className="col-md-6 mb-4"
                        key={item.id}
                    >

                        <div className="card shadow h-100">

                            <div className="card-body">

                                <h5>
                                    {item.title}
                                </h5>

                                <hr/>

                                <p>
                                    <strong>Raised By :</strong>{" "}
                                    {item.raised_by}
                                </p>

                                <p>
                                    <strong>Description :</strong>
                                </p>

                                <p>
                                    {item.description}
                                </p>

                                <hr/>

                                <p>

                                    <strong>Status :</strong>{" "}

                                    {item.status === "OPEN" ? (
                                        <span className="badge bg-danger">
                      OPEN
                    </span>
                                    ) : (
                                        <span className="badge bg-success">
                      RESOLVED
                    </span>
                                    )}

                                </p>

                                <p>
                                    <strong>Resolution :</strong>
                                </p>

                                <p>
                                    {item.resolution || "Pending Resolution"}
                                </p>

                            </div>

                        </div>

                    </div>
                ))}

            </div>

        </section>
    );
}
export default WorkerDisputes;